import { Link } from "react-router-dom";
import { ArrowUpRight, Mail, Phone } from "lucide-react";
import { CONTACT, BROCHURE_URL, MAIN_REGISTRATION_FORM, NAV_LINKS } from "@/data/eventData";

const Footer = () => (
    <footer data-testid="footer" className="border-t border-cream/5 bg-coal/60">
        <div className="mx-auto grid max-w-[1400px] gap-14 px-5 py-16 md:grid-cols-[1.4fr_1fr_1fr] md:px-10 md:py-24">
            <div>
                <p className="font-serif text-4xl font-light leading-tight tracking-tight text-cream md:text-5xl">
                    I-ACE
                    <br />
                    <span className="italic text-scarlet">Chapter 4</span>
                </p>
                <p className="mt-6 max-w-xs text-sm font-light leading-relaxed text-ash">
                    The One Percent Club
                    <br />
                    Banaras Hindu University
                </p>
            </div>

            <div>
                <p className="font-sans text-[11px] font-semibold uppercase tracking-[0.35em] text-scarlet">
                    Quick Links
                </p>
                <ul className="mt-6 space-y-4">
                    {NAV_LINKS.map((link) => (
                        <li key={link.to}>
                            <Link
                                to={link.to}
                                data-testid={`footer-link-${link.label.toLowerCase()}`}
                                className="group inline-flex items-center gap-2 text-sm font-light text-ash transition-colors duration-300 hover:text-cream"
                            >
                                {link.label}
                                <ArrowUpRight className="h-3.5 w-3.5 text-scarlet opacity-0 transition-all duration-300 group-hover:translate-x-0.5 group-hover:opacity-100" />
                            </Link>
                        </li>
                    ))}
                    <li>
                        <a
                            href={MAIN_REGISTRATION_FORM}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-link-register"
                            className="group inline-flex items-center gap-2 text-sm font-light text-ash transition-colors duration-300 hover:text-cream"
                        >
                            Register
                            <ArrowUpRight className="h-3.5 w-3.5 text-scarlet opacity-0 transition-all duration-300 group-hover:translate-x-0.5 group-hover:opacity-100" />
                        </a>
                    </li>
                    <li>
                        <a
                            href={BROCHURE_URL}
                            download="I-ACE-4.0-Brochure.pdf"
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-link-brochure"
                            className="group inline-flex items-center gap-2 text-sm font-light text-ash transition-colors duration-300 hover:text-cream"
                        >
                            Brochure
                            <ArrowUpRight className="h-3.5 w-3.5 text-scarlet opacity-0 transition-all duration-300 group-hover:translate-x-0.5 group-hover:opacity-100" />
                        </a>
                    </li>
                </ul>
            </div>

            <div>
                <p className="font-sans text-[11px] font-semibold uppercase tracking-[0.35em] text-scarlet">
                    Contact
                </p>
                <ul className="mt-6 space-y-4 text-sm font-light text-ash">
                    {CONTACT.phones.map((phone) => (
                        <li key={phone}>
                            <a
                                href={`tel:+91${phone}`}
                                data-testid={`footer-contact-phone-${phone}`}
                                className="flex items-center gap-3 transition-colors duration-300 hover:text-cream"
                            >
                                <Phone className="h-4 w-4 shrink-0 text-crimson" />
                                +91 {phone}
                            </a>
                        </li>
                    ))}
                    <li>
                        <a
                            href={`mailto:${CONTACT.email}`}
                            data-testid="footer-contact-email"
                            className="flex items-center gap-3 transition-colors duration-300 hover:text-cream"
                        >
                            <Mail className="h-4 w-4 shrink-0 text-crimson" />
                            {CONTACT.email}
                        </a>
                    </li>
                    {CONTACT.socials.map((social) => (
                        <li key={social.label} data-testid={`footer-social-${social.label.toLowerCase()}`}>
                            {social.href ? (
                                <a
                                    href={social.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="group inline-flex items-center gap-2 transition-colors duration-300 hover:text-cream"
                                >
                                    <span className="text-cream/70 group-hover:text-cream">
                                        {social.label}
                                    </span>
                                    <span className="text-ash/60">{social.value}</span>
                                    <ArrowUpRight className="h-3.5 w-3.5 text-scarlet opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
                                </a>
                            ) : (
                                <span>
                                    <span className="text-cream/70">{social.label}</span>
                                    <span className="ml-3 text-ash/60">{social.value}</span>
                                </span>
                            )}
                        </li>
                    ))}
                </ul>
            </div>
        </div>

        <div className="border-t border-cream/5">
            <div className="mx-auto flex max-w-[1400px] flex-col gap-3 px-5 py-6 font-sans text-[10px] uppercase tracking-[0.25em] text-ash/50 md:flex-row md:items-center md:justify-between md:px-10">
                <span>I-ACE Chapter 4 · The One Percent Club, BHU</span>
                <span>Debate today. Shape tomorrow.</span>
            </div>
        </div>
    </footer>
);

export default Footer;
